import './src/css/tailwind.css';
import './src/fonts/strio/strio.css';
